const CadastrosPesquisaSatisfacao = () =>
  import(/* webpackChunkName: "group-satisfaction-research"*/ '../views/CadastrosPesquisaSatisfacao')

import cadastrosPesquisaSatisfacaoRoutes from '../modules/pesquisaSatisfacao/_routes'

import { permissoesCadastroPesquisa } from '../../../utils/permissoesPesquisaSatisfacao'

export default [
  {
    path: 'cadastro',
    component: CadastrosPesquisaSatisfacao,
    meta: { requiresAuth: true, permissions: [...permissoesCadastroPesquisa] },
    children: [...cadastrosPesquisaSatisfacaoRoutes],
  },
]
